import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReportImageDisplay } from '../../../../Util/Modals/CustomizableReports/CustomizableReports';
import './TextDoubleIndicator.scss';

const isReportDetail = (forReport: ReportImageDisplay | undefined, baseColor: string) => {
  return forReport && forReport === ReportImageDisplay.Detail ? { color: 'white' } : { color: baseColor };
};

type Props = {
  data: any;
  forReport?: ReportImageDisplay;
};
const TextDoubleIndicator = ({ data, forReport }: Props) => {
  const { t } = useTranslation();
  const { list } = data ? data : [];
  const processes_should_be_published = 'new_processes_that_should_be_published';
  const processes_should_be_contracted = 'new_processes_that_should_be_contracted';
  return (
    <div className="text-double-indicator-container text-double-indicator">
      {data ? (
        list.map(item => (
          <div
            className="horizontal"
            style={{
              marginBottom:
                item.text === processes_should_be_published || item.text === processes_should_be_contracted
                  ? '0px'
                  : '18px',
            }}
            key={item.id}>
            <div className="value">
              {item.value}
            </div>
            <div className="subtitle">
              {t(item.text)}
            </div>
          </div>
        ))
      ) : (
        <div className="empty-data">
          <p className="bold-text">
            -
          </p>
        </div>
      )}
    </div>
  );
};

export { TextDoubleIndicator };
